import React, { useState } from 'react'
import { Typography, Card, CardContent, Grid, Stepper, Step, StepLabel } from '@mui/material'
import convertMillisecondsToMinutes from '../../../utils/convertMillisecondsToMinutes'
import formatMoney from '../../../utils/formatMoney'
import moment from 'moment'
import displayBookedLessonStateForStudents from '../../../utils/displayBookedLessonStateForStudents'
import { Cancel } from '@mui/icons-material'

const BookedLessonInfo = ({ bookedLesson }) => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = ['Bài học được đặt', 'Người học đã gửi khiếu nại về bài học', 'Bài học thành công'];

  const isStepOptional = (step) => {
    return step === 1;
  };

  if (bookedLesson && bookedLesson.state === 'Lesson booked' && activeStep !== 0) {
    setActiveStep(0)
  } else if (bookedLesson && bookedLesson.state === 'Student complained about the lesson' && activeStep !== 1) {
    setActiveStep(1)
  } else if (bookedLesson && bookedLesson.state === 'Lesson succeeded' && activeStep !== 2) {
    setActiveStep(2)
  }

  return (
    <Card>
      <CardContent>
        <Grid container direction="column" alignItems="center">
          <Grid item>
            <Typography
              variant="h5"
              style={{ textTransform: 'uppercase', fontWeight: '500' }}
            >
              Thông tin bài học
            </Typography>
          </Grid>

          <Grid item style={{ textAlign: 'center' }}>
            <Typography variant='body1'><strong>Tình trạng bài học:</strong></Typography>
          </Grid>

          {bookedLesson && bookedLesson.state === 'Lesson has been canceled by teacher' ? <Grid item>
            <Grid container justifyContent='center' alignItems='center' spacing={1}>
              <Grid item>
                <Cancel size='md' style={{ color: 'red' }} />
              </Grid>

              <Grid item>
                <Typography variant='body1' style={{ color: 'red' }}>Bài học đã bị hủy bỏ bởi giáo viên</Typography>
              </Grid>
            </Grid>
          </Grid> : <Grid item>
            <Stepper activeStep={activeStep} alternativeLabel>
              {steps.map((label, index) => {
                const stepProps = {};
                const labelProps = {};
                if (isStepOptional(index)) {
                  labelProps.optional = (
                    <Typography variant="caption">Tùy chọn</Typography>
                  );
                }
                return (
                  <Step key={label} {...stepProps}>
                    <StepLabel {...labelProps}>{label}</StepLabel>
                  </Step>
                );
              })}
            </Stepper>
          </Grid>}

          <Grid
            item
            container
            direction="column"
            alignItems="flex-start"
            style={{ marginTop: '1em' }}
          >
            <Grid item>
              <Typography variant="body1">
                <strong>Tên bài học:</strong>&nbsp;
                {bookedLesson &&
                  bookedLesson.lesson &&
                  bookedLesson.lesson.lessonName &&
                  bookedLesson.lesson.lessonName}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1">
                <strong>Thời lượng:</strong>&nbsp;
                {bookedLesson &&
                  bookedLesson.duration &&
                  convertMillisecondsToMinutes(bookedLesson.duration)}{' '}
                phút
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1">
                <strong>Giá tiền:</strong>&nbsp;
                {bookedLesson &&
                  bookedLesson.price &&
                  formatMoney(bookedLesson.price)}{' '}
                VNĐ
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                <strong>Tình trạng:</strong>&nbsp;
                {displayBookedLessonStateForStudents(bookedLesson.state)}
              </Typography>
            </Grid>

            <Grid item>
              <Typography variant="body1">
                <strong>Thời gian bắt đầu:</strong>&nbsp;
                {bookedLesson &&
                  bookedLesson.bookedTime &&
                  bookedLesson.bookedTime.length > 0 &&
                  moment(bookedLesson.bookedTime[0].start).format(
                    'HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY'
                  )}
              </Typography>
            </Grid>
            <Grid item>
              <Typography variant="body1">
                <strong>Thời gian kết thúc:</strong>&nbsp;
                {bookedLesson && bookedLesson.duration === 1800000
                  ? moment(bookedLesson.bookedTime[0].start)
                    .add(30, 'minutes')
                    .format('HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY')
                  : bookedLesson && bookedLesson.duration === 2700000
                    ? moment(bookedLesson.bookedTime[0].start)
                      .add(45, 'minutes')
                      .format('HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY')
                    : bookedLesson &&
                      bookedLesson.duration &&
                      bookedLesson.duration === 3600000
                      ? moment(bookedLesson.bookedTime[0].start)
                        .add(60, 'minutes')
                        .format('HH [giờ] mm [phút], [ngày] DD, MMMM, YYYY')
                      : null}
              </Typography>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default BookedLessonInfo
